// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#TDMSourceList {\n  min-height: 45vh;\n  height: 60vh;\n}\n\n#TDMResultList {\n  min-height: 45vh;\n  height: 60vh;\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
